import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ValidateService} from "../../../../resources/modules/validate/validate.service";
import {Subscription} from "rxjs";
import {FormService} from "../../../../resources/services/form.service";

@Component({
  selector: 'ui-form-group',
  templateUrl: './ui-form-group.component.html'
})
export class UiFormGroupComponent implements OnInit, OnDestroy {

  mockUpFiles = [
    {
      "ETag": "\"cb75804b970e285d1d9cee668e890e0e\"",
      "Location": "http://amayacloudserver.hb.bizmrg.com/logo%202.svg",
      "key": "logo 2.svg",
      "Key": "logo 2.svg",
      "Bucket": "amayacloudserver",
      "storageProvider": "mcs",
      "meta": null,
      "size": null,
      "type": null,
      "platform": null,
      "id": 18,
      "createdAt": "2020-07-03T13:42:42.652Z",
      "updatedAt": "2020-07-03T13:42:42.652Z"
    },
    {
      "ETag": "\"59b4823e2143ce298017a4426215aa38\"",
      "Location": "http://amayacloudserver.hb.bizmrg.com/logo.svg",
      "key": "logo.svg",
      "Key": "logo.svg",
      "Bucket": "amayacloudserver",
      "storageProvider": "mcs",
      "meta": null,
      "size": null,
      "type": null,
      "platform": null,
      "id": 20,
      "createdAt": "2020-07-03T13:42:43.267Z",
      "updatedAt": "2020-07-03T13:42:43.267Z"
    },
    {
      "ETag": "\"e6431f0b22c751403e64acd0b0434988\"",
      "Location": "http://amayacloudserver.hb.bizmrg.com/Fira_Sans.zip",
      "key": "Fira_Sans.zip",
      "Key": "Fira_Sans.zip",
      "Bucket": "amayacloudserver",
      "storageProvider": "mcs",
      "meta": null,
      "size": null,
      "type": null,
      "platform": null,
      "id": 100,
      "createdAt": "2020-07-07T10:11:50.612Z",
      "updatedAt": "2020-07-07T10:11:50.612Z"
    }
  ];

  mockUpRoles = [
    {
      title: 'Administrator',
      id: '1',
    },
    {
      title: 'Moderator',
      id: '2',
    },
    {
      title: 'User',
      id: '3',
    }
  ];

  mockUpCountries = [
    {
      title: 'USA',
      id: '1',
    },
    {
      title: 'Russia',
      id: '2',
    },
    {
      title: 'Ukraine',
      id: '3',
    }
  ];

  mockUpData = {
    name: 'Sergey',
    age: '18',
    description: 'Lorem impsum dollar',
    active: false,
    role: '1',
    birthday: new Date(),
    country: '2',
    city: 'Moscow',
    control: 'Test control',
    nameControl: 'Name Control',
    files: this.mockUpFiles[0],
  };
  disabled: boolean = false;

  form: FormGroup = new FormGroup({
    name: new FormControl(null, [Validators.required]),
    age: new FormControl(null, [Validators.required]),
    country: new FormControl(null, [Validators.required]),
    description: new FormControl(),
    birthday: new FormControl(null, [Validators.required]),
    active: new FormControl(true),
    role: new FormControl(null, [Validators.required]),
    files: new FormControl(),
  });

  adminForms: any = {
    control: new FormControl(),
    nameControl: new FormControl(null, [Validators.required]),
  };

  countryForms: any = {
    city: new FormControl()
  };

  roleChange$: Subscription;
  countryChange$: Subscription;

  constructor(private validateService: ValidateService,
              private formService: FormService) { }

  ngOnInit(): void {
    this.roleChange$ = this.form.get('role').valueChanges.subscribe((result) => {
      this.formService.toggleControls(this.form, this.adminForms, result === '1');
    });

    this.countryChange$ = this.form.get('country').valueChanges.subscribe((result) => {
      this.formService.toggleControls(this.form, this.countryForms, result);
    });

    this.form.valueChanges.subscribe((data) => {
      console.log('valueChanges data: ', data);
    })
  }

  ngOnDestroy() {
    this.roleChange$.unsubscribe();
  }

  validate() {
    console.log('form valid: ', this.validateService.validate(this.form))
  }

  setData() {
    this.form.patchValue(this.mockUpData);
    this.formService.setDefaultValues(this.form);
  }

  toggleDisabled() {
    this.disabled = !this.disabled;

    if (this.disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  typeof(value) {
    return typeof value;
  }

  checkChanges() {
    this.formService.checkChanges(this.form);
  }
}
